/** @format */

import React, { Component } from "react";
import { Link } from "react-router-dom";
import { UncontrolledCollapse, Button, CardBody, Card } from "reactstrap";

import "../css/menu.css";
import Constantes from "../util/Constantes";
import MenuIcon from "@material-ui/icons/Menu";
import CancelIcon from "@material-ui/icons/Cancel";

//ICONOS
import SchoolIcon from "@material-ui/icons/School";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import TodayIcon from "@material-ui/icons/Today";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import Salir from "../assets/img/salir.svg";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Alert } from "bootstrap";
//FIN ICONOS
function ActiveSlider_PG(_isMobile) {
  let URLactual = window.location;

  let home = document.getElementById("home");
  let curso = document.getElementById("curso");
  let horario = document.getElementById("horarios");
  let pagos = document.getElementById("pagos");
  let historial = document.getElementById("historial");
  if (home.classList.contains("active-menu")) {
    home.classList.remove("active-menu");
  }
  if (curso.classList.contains("active-menu")) {
    curso.classList.remove("active-menu");
  }
  if (horario.classList.contains("active-menu")) {
    horario.classList.remove("active-menu");
  }
  if (pagos.classList.contains("active-menu")) {
    pagos.classList.remove("active-menu");
  }
  if (historial.classList.contains("active-menu")) {
    historial.classList.remove("active-menu");
  }
  if (URLactual.pathname == "/home") {
    home.classList.add("active-menu");
  } else if (URLactual.pathname == "/curso") {
    curso.classList.add("active-menu");
  } else if (URLactual.pathname == "/horarios") {
    horario.classList.add("active-menu");
  } else if (URLactual.pathname == "/pagos") {
    pagos.classList.add("active-menu");
  } else if (URLactual.pathname == "/historial-academico") {
    historial.classList.add("active-menu");
  }
  if (_isMobile) {
    let instalar = document.getElementById("instalar");
    if (instalar.classList.contains("active-menu")) {
      instalar.classList.remove("active-menu");
    }
    if (URLactual.pathname == "/Como-instalar") {
      instalar.classList.add("active-menu");
    }
  }
}
export default class Sidebar extends Component {
  render() {
    const _isMobile = this.props.isMobile;
    const handleClickOcultar = async () => {
      ActiveSlider_PG(_isMobile);
      let sidebar = document.getElementById("SidebarList");
      let IconActive = document.getElementById("Icon-Active");
      let IconCancel = document.getElementById("Icon-Cancel");
      if (
        sidebar.classList.value == "SidebarListHide" ||
        sidebar.classList.value == ""
      ) {
        sidebar.classList.remove("SidebarListHide");
        sidebar.classList.add("SidebarList");
        IconActive.classList.remove("SidebarListHideIcon");
        IconCancel.classList.add("SidebarListHideIcon");
      } else {
        sidebar.classList.remove("SidebarList");
        sidebar.classList.add("SidebarListHide");
        IconActive.classList.add("SidebarListHideIcon");
        IconCancel.classList.remove("SidebarListHideIcon");
      }
    };
    const handleClickSalir = async () => {
      localStorage.removeItem("userLogin");
      localStorage.removeItem("studientActive");
      localStorage.removeItem("studientList");
      window.location.href = "/Login";
    };
    return (
      <div className="Sidebar">
        <div style={{ textAlign: "center", padding: "1rem" }}>
          <img src={Constantes().Imagen.LogoMovil} className="logo" />
        </div>
        <div className="menu-list">
          <label id="Icon-Active" htmlFor="menu">
            <i>
              <MenuIcon
                style={{ color: "#FDBA30" }}
                onClick={handleClickOcultar}
              />
            </i>
          </label>
          <label
            id="Icon-Cancel"
            className="SidebarListHideIcon"
            htmlFor="menu"
          >
            <i>
              <CancelIcon
                style={{ color: "#FDBA30" }}
                onClick={handleClickOcultar}
              />
            </i>
          </label>
        </div>
        <ul id="SidebarList" className="SidebarList">
          <li
            id="home"
            className="row active-menu"
            onClick={handleClickOcultar}
          >
            <div id="icon">
              <SchoolIcon />
            </div>
            <Link id="tittle" to="/home">
              ESTUDIANTE
            </Link>
          </li>
          <li id="curso" className="row" onClick={handleClickOcultar}>
            <div id="icon">
              <ImportContactsIcon />
            </div>
            <Link id="tittle" to="/curso">
              CURSOS
            </Link>
          </li>
          <li id="horarios" className="row" onClick={handleClickOcultar}>
            <div id="icon">
              <TodayIcon />
            </div>
            <Link id="tittle" to="/horarios">
              HORARIOS
            </Link>
          </li>
          <li id="pagos" className="row" onClick={handleClickOcultar}>
            <div id="icon">
              <AccountBalanceWalletIcon />
            </div>
            <Link id="tittle" to="/pagos">
              PAGOS
            </Link>
          </li>
          <li id="historial" className="row" onClick={handleClickOcultar}>
            <div id="icon">
              <LibraryBooksIcon />
            </div>
            <Link id="tittle" to="/historial-academico">
              HISTORIAL ACADEMICO
            </Link>
          </li>
          {_isMobile ? (
            <li
              ID="instalar"
              className="row instalar-app"
              onClick={handleClickOcultar}
            >
              <div id="icon">
                <GetAppIcon />
              </div>
              <Link id="tittle" to="/Como-instalar">
                INSTALAR
              </Link>
            </li>
          ) : null}
          <li className="row" onClick={handleClickSalir}>
            <div id="icon">
              <img src={Salir} />
            </div>
            <Link id="tittle" to="/salir">
              SALIR
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}
